const INTV_PROMPT_ANSWERS = [
    {
        id: "answer-wound-location-head",
        label: "Wound located at head",
        abbrLabel: "Head",
        promptID: "prompt-wound-location"
    }, {
        id: "answer-wound-location-neck",
        label: "Wound located at neck",
        abbrLabel: "Neck",
        promptID: "prompt-wound-location"
    }, {
        id: "answer-wound-location-chest",
        label: "Wound located at chest",
        abbrLabel: "Chest",
        promptID: "prompt-wound-location"
    }, {
        id: "answer-wound-location-abdomen-pelvis",
        label: "Wound located at abdomen/pelvis",
        abbrLabel: "Abdomen/Pelvis",
        promptID: "prompt-wound-location"
    }, {
        id: "answer-wound-location-posterior",
        label: "Wound located at posterior thorax, lumbar, or buttocks",
        abbrLabel: "Posterior",
        promptID: "prompt-wound-location"
    }, {
        id: "answer-wound-location-genitalia",
        label: "Wound located at genitalia",
        abbrLabel: "Genitalia",
        promptID: "prompt-wound-location"
    }, {
        id: "answer-wound-location-left-lower-extremity",
        label: "Wound located at left lower extremity",
        abbrLabel: "Left lower extremity",
        promptID: "prompt-wound-location"
    }, {
        id: "answer-wound-location-right-lower-extremity",
        label: "Wound located at right lower extremity",
        abbrLabel: "Right lower extremity",
        promptID: "prompt-wound-location"
    }, {
        id: "answer-wound-location-left-upper-extremity",
        label: "Wound located at left upper extremity",
        abbrLabel: "Left upper extremity",
        promptID: "prompt-wound-location"
    }, {
        id: "answer-wound-location-right-upper-extremity",
        label: "Wound located at right upper extremity",
        abbrLabel: "Right upper-extremity",
        promptID: "prompt-wound-location"
    }, {
        id: "answer-wound-location-other",
        label: "Other wound location",
        abbrLabel: "Other",
        promptID: "prompt-wound-location"
    },

    {
        id: "answer-wound-locations-head",
        label: "Wound located at head",
        abbrLabel: "Head",
        promptID: "prompt-wound-locations"
    }, {
        id: "answer-wound-locations-neck",
        label: "Wound located at neck",
        abbrLabel: "Neck",
        promptID: "prompt-wound-locations"
    }, {
        id: "answer-wound-locations-chest",
        label: "Wound located at chest",
        abbrLabel: "Chest",
        promptID: "prompt-wound-locations"
    }, {
        id: "answer-wound-locations-abdomen-pelvis",
        label: "Wound located at abdomen/pelvis",
        abbrLabel: "Abdomen/Pelvis",
        promptID: "prompt-wound-locations"
    }, {
        id: "answer-wound-locations-posterior",
        label: "Wound located at posterior thorax, lumbar, or buttocks",
        abbrLabel: "Posterior",
        promptID: "prompt-wound-locations"
    }, {
        id: "answer-wound-locations-genitalia",
        label: "Wound located at genitalia",
        abbrLabel: "Genitalia",
        promptID: "prompt-wound-locations"
    }, {
        id: "answer-wound-locations-left-lower-extremity",
        label: "Wound located at left lower extremity",
        abbrLabel: "Left lower extremity",
        promptID: "prompt-wound-locations"
    }, {
        id: "answer-wound-locations-right-lower-extremity",
        label: "Wound located at right lower extremity",
        abbrLabel: "Right lower extremity",
        promptID: "prompt-wound-locations"
    }, {
        id: "answer-wound-locations-left-upper-extremity",
        label: "Wound located at left upper extremity",
        abbrLabel: "Left upper extremity",
        promptID: "prompt-wound-locations"
    }, {
        id: "answer-wound-locations-right-upper-extremity",
        label: "Wound located at right upper extremity",
        abbrLabel: "Right upper-extremity",
        promptID: "prompt-wound-locations"
    }, {
        id: "answer-wound-locations-other",
        label: "Other wound location",
        abbrLabel: "Other",
        promptID: "prompt-wound-locations"
    },


    {
        "id": "answer-airway-patency-suction-yankauer",
        "label": "Yankauer",
        "promptID": "prompt-airway-patency-suction-device"
    }, {
        "id": "answer-airway-patency-suction-long-multiuse",
        "label": "Long, multiuse",
        "promptID": "prompt-airway-patency-suction-device"
    }, {
        "id": "answer-airway-patency-suction-other",
        "label": "Other",
        "promptID": "prompt-airway-patency-suction-device"
    },

    {
        "id": "answer-alternative-rescue-airway-type-ett",
        "label": "Endotracheal tube (ETT)",
        "promptID": "prompt-advanced-airway-adjunct-type"
    }, {
        "id": "answer-alternative-rescue-airway-type-combitube",
        "label": "Combitube",
        "promptID": "prompt-advanced-airway-adjunct-type"
    }, {
        "id": "answer-alternative-rescue-airway-type-lta",
        "label": "Laryngeal tube airway (LTA; King tube)",
        "promptID": "prompt-advanced-airway-adjunct-type"
    }, {
        "id": "answer-alternative-rescue-airway-type-lma",
        "label": "Laryngeal mask airway (LMA)",
        "promptID": "prompt-advanced-airway-adjunct-type"
    }, {
        "id": "answer-alternative-rescue-airway-type-igel",
        "label": "Igel",
        "promptID": "prompt-advanced-airway-adjunct-type"
    }, {
        "id": "answer-alternative-rescue-airway-type-other",
        "label": "Other",
        "promptID": "prompt-advanced-airway-adjunct-type"
    },

    {
        "id": "answer-alternative-airway-tube-size-7",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "7.0"
    }, {
        "id": "answer-alternative-airway-tube-size-8",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "8.0"
    }, {
        "id": "answer-alternative-airway-tube-size-age-div-4-plus-4",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "((age/4 + 4))"
    }, {
        "id": "answer-alternative-airway-tube-size--age-div-4-plus-4-minus-5",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "((age/4 + 4) - 5"
    }, {
        "id": "answer-alternative-airway-tube-size-37f",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "37F"
    },{
        "id": "answer-alternative-airway-tube-size-41f",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "41F"
    }, {
        "id": "answer-alternative-airway-tube-size-0",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "0"
    }, {
        "id": "answer-alternative-airway-tube-size-1",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "1"
    }, {
        "id": "answer-alternative-airway-tube-size-1-5",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "1.5"
    }, {
        "id": "answer-alternative-airway-tube-size-2",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "2"
    }, {
        "id": "answer-alternative-airway-tube-size-2-5",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "2.5"
    }, {
        "id": "answer-alternative-airway-tube-size-3",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "3"
    },{
        "id": "answer-alternative-airway-tube-size-4",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "4"
    },{
        "id": "answer-alternative-airway-tube-size-5",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "5"
    },{
        "id": "answer-alternative-airway-tube-size-6",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "6"
    },{
        "id": "answer-alternative-airway-tube-size-other",
        "promptID": "prompt-advanced-airway-tube-size",
        "label": "Other"
    },

    {
        "id": "answer-orotracheal-intubation-tube-insertion-depth-21cm",
        "promptID": "prompt-orotracheal-intubation-tube-insertion-depth",
        "label": "21cm"
    },{
        "id": "answer-orotracheal-intubation-tube-insertion-depth-23cm",
        "promptID": "prompt-orotracheal-intubation-tube-insertion-depth",
        "label": "23cm"
    },{
        "id": "answer-orotracheal-intubation-tube-insertion-depth-3-times-tube-size",
        "promptID": "prompt-orotracheal-intubation-tube-insertion-depth",
        "label": "3 x tube size"
    },{
        "id": "answer-orotracheal-intubation-tube-insertion-depth-other",
        "promptID": "prompt-orotracheal-intubation-tube-insertion-depth",
        "label": "Other"
    },

    {
        "id": "answer-nasotracheal-intubation-tube-size-6-to-6-5",
        "promptID": "prompt-nasotracheal-intubation-tube-size",
        "label": "6.0 - 6.5"
    },
    {
        "id": "answer-nasotracheal-intubation-tube-size-7-to-7-5",
        "promptID": "prompt-nasotracheal-intubation-tube-size",
        "label": "7.0 - 7.5"
    },{
        "id": "answer-nasotracheal-intubation-tube-size-age-div-4+4-minus1",
        "promptID": "prompt-nasotracheal-intubation-tube-size",
        "label": "(age/4 - 4)-1"
    },{
        "id": "answer-nasotracheal-intubation-tube-size-age-div-4+4-minus0-5",
        "promptID": "prompt-nasotracheal-intubation-tube-size",
        "label": "(age/4 -4) - 0.5"
    },{
        "id": "answer-nasotracheal-intubation-tube-size-0-5-1cm-less-than-oro-size",
        "promptID": "prompt-nasotracheal-intubation-tube-size",
        "label": ".5 - 1cm less then size for orotracheal tube size"
    },{
        "id": "answer-nasotracheal-intubation-tube-size-other",
        "promptID": "prompt-nasotracheal-intubation-tube-size",
        "label": "Other"
    },

    {
        "id": "answer-nasal-cannula-flow-rate-1-6-lpm",
        "promptID": "prompt-nasal-cannula-flow-rate",
        "label": "Nasal cannula flow rate 1-6 liters/min",
        "abbrLabel": "1-6 liters/min"
    },{
        "id": "answer-nasal-cannula-flow-rate-other",
        "promptID": "prompt-nasal-cannula-flow-rate",
        "label": "Nasal cannula flow rate other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-nasal-cannula-target-saturation-gt-90-pct",
        "promptID": "prompt-nasal-cannula-target-saturation",
        "label": "Nasal cannula target saturation: 90% or greater",
        "abbrLabel": "90% or greater"
    },{
        "id": "answer-nasal-cannula-target-saturation-other",
        "promptID": "prompt-nasal-cannula-target-saturation",
        "label": "Nasal cannula target saturation: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-non-rebreather-mask-flow-rate-10-15-liters-min",
        "promptID": "prompt-non-rebreather-mask-flow-rate",
        "label": "Non-rebreather mask flow rate 10-15 L/min",
        "abbrLabel": "10-15 L/min"
    }, {
        "id": "answer-non-rebreather-mask-flow-rate-other",
        "promptID": "prompt-non-rebreather-mask-flow-rate",
        "label": "Non-rebreather mask flow rate other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-non-rebreather-mask-target-saturation-gt-90-pct",
        "promptID": "prompt-non-rebreather-mask-target-saturation",
        "label": "Non-rebreather mask target O2 saturation: 90% or greater",
        "abbrLabel": "90% or greater"
    },{
        "id": "answer-non-rebreather-mask-target-saturation-other",
        "promptID": "prompt-non-rebreather-mask-target-saturation",
        "label": "Non-rebreather mask target O2 saturation: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-bvm-ventilation-rate-10-12-bpm",
        "promptID": "prompt-bvm-ventilation-rate",
        "label": "BVM ventilation rate: 10-12 BPM",
        "abbrLabel": "10-12 breaths/minute"
    }, {
        "id": "answer-bvm-ventilation-rate-other",
        "promptID": "prompt-bvm-ventilation-rate",
        "label": "BVM ventilation rate: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-bvm-flow-rate-15-ltm-or-gt",
        "promptID": "prompt-bvm-flow-rate",
        "label": "BVM flow rate: 15 liters/min or greater",
        "abbrLabel": "15 liters/min or greater"
    }, {
        "id": "answer-bvm-flow-rate-other",
        "promptID": "prompt-bvm-flow-rate",
        "label": "BVM flow rate: other",
        "abbrLabel": "Other"
    },
    {
        "id": "answer-bvm-target-saturation-rate-gt-90-pct",
        "promptID": "prompt-bvm-target-saturation",
        "label": "BVM target O2 saturation rate 90% or greater",
        "abbrLabel": "90% or greater"
    },{
        "id": "answer-bvm-target-saturation-rate-other",
        "promptID": "prompt-bvm-target-saturation",
        "label": "BVM target O2 saturation rate other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-tourniquet-placement-close-to-core-far-from-wound",
        "promptID": "prompt-tourniquet-placement",
        "label": "Tourniquet placement as far from wound and close to the core as possible",
        "abbrLabel": "As far from wound and close to the core as possible"
    },{
        "id": "answer-tourniquet-placement-other",
        "promptID": "prompt-tourniquet-placement",
        "label": "Tourniquet placement other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-2nd-tourniquet-placement-adjacent-to-initial-tourniquet",
        "promptID": "prompt-2nd-tourniquet-placement",
        "label": "Second tourniquet location: adjacent to initial tourniquet",
        "abbrLabel": "Adjacent to initial tourniquet"
    },{
        "id": "answer-2nd-tourniquet-placement-other",
        "promptID": "prompt-2nd-tourniquet-placement",
        "label": "Second tourniquet location: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-occulsivive-dressing-injury-type-open-pneumothorax",
        "promptID": "prompt-occlusive-dressing-injury-type",
        "label": "Occlusive dressing injury type: Open pnuemothorax (sucking chest wound)",
        "abbrLabel": "Open pnuemothorax (sucking chest wound)"
    },{
        "id": "answer-occulsivive-dressing-injury-type-other",
        "promptID": "prompt-occlusive-dressing-injury-type",
        "label": "Occlusive dressing injury type: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-occulsive-dressing-method-leave-one-side-untaped",
        "promptID": "prompt-occlusive-dressing-method",
        "label": "Occlusive dressing method: Leave one side untaped",
        "abbrLabel": "Leave one side untaped"
    },{
        "id": "answer-occulsive-dressing-method-leave-dressing-with-one-way-valve",
        "promptID": "prompt-occlusive-dressing-method",
        "label": "Occlusive dressing method: Dressing with one-way valve (e.g. Hyfin chest seal, Asherman chest seal)",
        "abbrLabel": "Dressing with one-way valve (e.g. Hyfin chest seal, Asherman chest seal)"
    },{
        "id": "answer-occulsive-dressing-method-other",
        "promptID": "prompt-occlusive-dressing-method",
        "label": "Occlusive dressing method: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-pleural-decompression-injury-type-tension-pneumothorax",
        "promptID": "prompt-pleural-decompression-injury-type",
        "label": "Pleural decompression injury type: tension pneumothorax",
        "abbrLabel": "Tension pneumothorax"
    },{
        "id": "answer-pleural-decompression-injury-type-open-pneumothorax",
        "promptID": "prompt-pleural-decompression-injury-type",
        "label": "Pleural decompression injury type: Open pnuemothorax (sucking chest wound)",
        "abbrLabel": "Open pnuemothorax (sucking chest wound)"
    },{
        "id": "answer-pleural-decompression-injury-type-other",
        "promptID": "prompt-pleural-decompression-injury-type",
        "label": "Pleural decompression injury type: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-pleural-decompression-needle-placement-side-of-the-body-right",
        "promptID": "prompt-pleural-decompression-needle-placement-side-of-the-body",
        "label": "Pleural Decompression needle placement: right side",
        "abbrLabel": "Right"
    },{
        "id": "answer-pleural-decompression-needle-placement-side-of-the-body-left",
        "promptID": "prompt-pleural-decompression-needle-placement-side-of-the-body",
        "label": "Pleural Decompression needle placement: left side",
        "abbrLabel": "Left"
    },

    {
        "id": "answer-pleural-decompression-needle-placement-anatomical-landmark-2nd-or-3rd-intercostal-space-mid-clavicular",
        "promptID": "prompt-pleural-decompression-needle-placement-anatomical-landmark",
        "label": "Pleural decompression anatomical landmark: Second or third intercostal space mid-clavicular line",
        "abbrLabel": "Second or third intercostal space mid-clavicular line"
    },{
        "id": "answer-pleural-decompression-needle-placement-anatomical-landmark-4th-or-5th-intercostal-space-mid-axillary",
        "promptID": "prompt-pleural-decompression-needle-placement-anatomical-landmark",
        "label": "Pleural decompression anatomical landmark: Fourth or fifth intercostal space mid-axillary line",
        "abbrLabel": "Fourth or fifth intercostal space mid-axillary line"
    },{
        "id": "answer-pleural-decompression-needle-placement-anatomical-landmark-other",
        "promptID": "prompt-pleural-decompression-needle-placement-anatomical-landmark",
        "label": "Pleural decompression anatomical landmark: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-pleural-decompression-needle-size-large-bore",
        "promptID": "prompt-pleural-decompression-needle-size",
        "label": "Pleural decompression needle size: Large bore (14 or 16 gauge)",
        "abbrLabel": "Large bore (14 or 16 gauge)"
    },{
        "id": "answer-pleural-decompression-needle-size-other",
        "promptID": "prompt-pleural-decompression-needle-size",
        "label": "Pleural decompression needle size: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-pleural-decompression-needle-length-2-inches-or-longer",
        "promptID": "prompt-pleural-decompression-needle-length",
        "label": "Pleural Decompression needle size: 2 inches or more",
        "abbrLabel": "2 inches or more"
    },{
        "id": "answer-pleural-decompression-needle-length-other",
        "promptID": "prompt-pleural-decompression-needle-length",
        "label": "Pleural Decompression needle size: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-transport-facility-choice-level-1-or-2-trauma-center",
        "promptID": "prompt-transport-facility-choice",
        "label": "Receiving facility type: Closest level 1 or 2 trauma center",
        "abbrLabel": "Closest level 1 or 2 trauma center"
    },{
        "id": "answer-transport-facility-choice-level-3-or-4-trauma-center",
        "promptID": "prompt-transport-facility-choice",
        "label": "Receiving facility type: Closet level 3 or 4 trauma center",
        "abbrLabel": "Closet level 3 or 4 trauma center"
    },{
        "id": "answer-transport-facility-choice-closest",
        "promptID": "prompt-transport-facility-choice",
        "label": "Receiving facility type: Closest receiving facility",
        "abbrLabel": "Closest receiving facility"
    },{
        "id": "answer-transport-facility-choice-other",
        "promptID": "prompt-transport-facility-choice",
        "label": "Receiving facility type: other",
        "abbrLabel": "Other"
    },

    {
        "id": "answer-transport-method-ambulance",
        "promptID": "prompt-transport-method",
        "label": "Ambulance",
        "abbrLabel": "Ambulance"
    },{
        "id": "answer-transport-method-helicopter",
        "promptID": "prompt-transport-method",
        "label": "Helicopter",
        "abbrLabel": "Helicopter"
    },

    {
        "id": "answer-transport-lights-sirens-yes",
        "promptID": "prompt-transport-lights-siren-decision",
        "label": "Use lights and sirens",
        "abbrLabel": "Yes"
    },{
        "id": "answer-transport-lights-sirens-no",
        "promptID": "prompt-transport-lights-siren-decision",
        "label": "Do not use lights and sirens",
        "abbrLabel": "No"
    },

    {
        "id": "answer-splint-type-board",
        "promptID": "prompt-splint-type",
        "label": "Splint type: Board splint",
        "abbrLabel": "Board splint"
    },{
        "id": "answer-splint-type-moldable",
        "promptID": "prompt-splint-type",
        "label": "Splint type: Moldable splint",
        "abbrLabel": "Moldable splint"
    },{
        "id": "answer-splint-type-traction",
        "promptID": "prompt-splint-type",
        "label": "Splint type: Traction splint",
        "abbrLabel": "Traction splint"
    },{
        "id": "answer-splint-type-pelvic-binder",
        "promptID": "prompt-splint-type",
        "label": "Splint type: Pelvic binder",
        "abbrLabel": "Pelvic binder"
    },{
        "id": "answer-splint-type-other",
        "promptID": "prompt-splint-type",
        "label": "Splint type: Other",
        "abbrLabel": "Other"
    },

]
/*
    {
        "id": "",
        "promptID": "",
        "label": "",
        "abbrLabel": ""
    },
*/

export default INTV_PROMPT_ANSWERS